module.exports = __webpack_public_path__ + "img/soja-selecionado.3a347b90.svg";